module.exports = __webpack_public_path__ + "ihd-logo.png?682164c7586734a1b4ce84eaf4d48710";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/ihd-logo.png
// module id = 69
// module chunks = 0